<template>
  <draggable :group="{ name: 'form' }" ghost-class="ghost" :list="nav" :animation="180"
             :move="canMove" :disabled="unavailable" filter="input, button" :prevent-on-filter="false"
             @start="beforeSort" @end="afterSort">
    <template v-for="item in nav">
      <div v-if="item.children" :key="item.index" class="menu__folder" :data-layer-node-id="item.index">
        <div tabindex="0" @keydown.enter.self.prevent="handleSetActive(item)" @keydown.space.self.prevent="handleSetActive(item)"
             @dblclick="beginRename(item)" @click="handleSetActive(item)" @contextmenu.prevent.stop="contain.handleContextMenu($event,item)"
             :data-layer-row="item.index"
             :class="['menu__item--folder', 'editor-layer-row', { 'is-active': handleGetActive(item), 'is-hidden': item.display, 'is-over': contain.overactive === item.index }]">
          <button type="button" class="editor-layer-folder-toggle"
                  :aria-label="(item.menu ? '收起文件组：' : '展开文件组：') + item.name" :aria-expanded="String(!!item.menu)"
                  @click.stop="openFolder(item)" @dblclick.stop>
            <i class="el-icon-caret-right" :class="{ 'is-expanded': item.menu }" aria-hidden="true"></i>
            <i :class="item.menu ? 'el-icon-folder-opened' : 'el-icon-folder'" aria-hidden="true"></i>
          </button>
          <input v-if="editingId === item.index" :ref="'rename-' + item.index" v-model="renameValue"
                 class="editor-layer-rename" :aria-label="'文件组名称：' + item.name" maxlength="100"
                 @click.stop @dblclick.stop @mousedown.stop @keydown.enter.stop.prevent="finishRename(item)"
                 @keydown.esc.stop.prevent="cancelRename" @blur="finishRename(item)">
          <span v-else class="menu__name" :title="item.name">{{ item.name }}</span>
          <span class="editor-layer-count" :title="'包含 ' + memberCount(item) + ' 个组件'">{{ memberCount(item) }}</span>
          <layer-actions :node="item" />
        </div>
        <div v-show="item.menu" class="menu__list" role="group" :aria-label="'文件组内容：' + item.name">
          <layer :count="count + 1" :nav="item.children"></layer>
        </div>
      </div>
      <div v-else :key="item.index" :data-layer-node-id="item.index" :data-layer-row="item.index"
           tabindex="0" @keydown.enter.self.prevent="handleSetActive(item)" @keydown.space.self.prevent="handleSetActive(item)"
           @click="handleSetActive(item)" @contextmenu.prevent.stop="contain.handleContextMenu($event,item)"
           @mouseover="contain.overactive=item.index" @mouseout="contain.overactive=undefined"
           :class="['menu__item', 'editor-layer-row', { 'is-active': handleGetActive(item), 'is-hidden': item.display, 'is-over': contain.overactive === item.index }]">
        <span class="menu__icon"><i :class="'iconfont ' + item.icon"></i></span>
        <span class="menu__name" :title="item.name">{{ item.name }}</span>
        <layer-actions :node="item" />
      </div>
    </template>
  </draggable>
</template>

<script>
import vuedraggable from 'vuedraggable'
import LayerActions from './layer-actions.vue'
import { locateNode, canEditNode } from '@/editor/core/node-operations'
export default {
  name: 'layer',
  inject: ['contain'],
  provide () { return { contain: this.contain } },
  components: { draggable: vuedraggable, LayerActions },
  props: { count: { type: Number, default: 1 }, nav: { type: Array, default: () => [] } },
  data: () => ({ editingId: '', renameValue: '' }),
  computed: {
    unavailable () { return !this.contain.projectRecord || this.contain.editorSaveReady === false || !!this.contain.editorVersionSwitching }
  },
  methods: {
    beforeSort () { this.contain.rememberStructure() },
    afterSort () { this.contain.rememberStructure() },
    canMove (event) {
      const dragged = event.draggedContext && event.draggedContext.element
      if (this.unavailable || !dragged || !canEditNode(locateNode(this.contain.nav, dragged.index))) return false
      const targetList = event.relatedContext && event.relatedContext.list
      let recognized = false, blocked = false
      const visit = (nodes, locked = false, moving = false) => {
        if (nodes === targetList) { recognized = true; blocked = locked || moving }
        nodes.forEach(node => { if (node.children) visit(node.children, locked || !!node.locked, moving || node === dragged) })
      }
      visit(this.contain.nav)
      return recognized && !blocked
    },
    memberCount (item) { return item.children ? item.children.reduce((sum, child) => sum + this.memberCount(child), 0) : 1 },
    handleGetActive (item) { return this.contain.active.includes(item.index) },
    handleSetActive (item) {
      if (this.contain.keys.ctrl) {
        const at = this.contain.active.indexOf(item.index)
        if (at === -1) this.contain.active.push(item.index)
        else this.contain.active.splice(at, 1)
      } else this.contain.active = [item.index]
    },
    beginRename (item) {
      if (this.unavailable || !canEditNode(locateNode(this.contain.nav, item.index))) return
      this.handleSetActive(item)
      this.editingId = item.index
      this.renameValue = item.name || '文件组'
      this.$nextTick(() => {
        const input = this.$refs['rename-' + item.index]
        const element = Array.isArray(input) ? input[0] : input
        if (element) { element.focus(); element.select() }
      })
    },
    finishRename (item) {
      if (this.editingId !== item.index) return
      const name = this.renameValue.trim()
      if (name && !this.unavailable && canEditNode(locateNode(this.contain.nav, item.index)) && name !== item.name) {
        this.contain.rememberStructure()
        this.$set(item, 'name', name)
        this.contain.rememberStructure()
      }
      this.cancelRename()
    },
    cancelRename () { this.editingId = ''; this.renameValue = '' },
    openFolder (item) {
      this.$set(item, 'menu', !item.menu)
    }
  }
}
</script>
